import { render, staticRenderFns } from "./SubmitPick.vue?vue&type=template&id=7251bf8e&"
import script from "./SubmitPick.vue?vue&type=script&lang=ts&"
export * from "./SubmitPick.vue?vue&type=script&lang=ts&"
import style0 from "./SubmitPick.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports